import {
    Box, Button, Grid,
    InputAdornment,
    // Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
    TextField, Typography
} from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { useEffect } from 'react'
import Notification from '../services/db/notification'
import objToXlsx from '../utils/objToXlsx'
import htmlToPdf from '../utils/htmlToPdf'
import { InfoContext } from '../services/Context/Info/context'
import { Search } from '@mui/icons-material'
import search from '../utils/searchEngine'
import AddNotification from './elements/AddNotification'

const Notifications = () => {
    const pdfRef = useRef(null)
    const [searchQuery, setsearchQuery] = useState();
    const { data: { notificationData }, setData } = useContext(InfoContext);
    useEffect(() => {
        if (!notificationData.length) new Notification().allNotifications().then(r => {
            setData(p => ({ ...p, notificationData: r }))
        })
    }, []);

    const searchData = search(searchQuery, notificationData, ['title'])

    const commonButtonProps = { variant: 'contained', size: 'medium', color: 'primary', fullWidth: true }
    return (
        <Box sx={{ paddingX: 5, height: '100%' }}>
            <Grid container direction='column' paddingTop={2} spacing={5} minHeight='100%'>
                <Grid item xs={12} paddingY={1}>
                    <Typography>Notifications</Typography>
                </Grid>
                <Grid item container xs={12} spacing={2}>
                    <Grid item container xs={9} spacing={2}>
                        <Grid item xs={12} container spacing={1}>
                            <Grid item xs={3}>
                                <AddNotification data={{ role: 'User' }} />
                            </Grid>
                            <Grid item xs={3}>
                                <AddNotification data={{ role: 'Service Provider' }} />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container spacing={1}>
                            <Grid item xs={3}>
                                <Button
                                    onClick={() => objToXlsx(notificationData, 'notification')}
                                    {...commonButtonProps}
                                >
                                    Excel
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    onClick={() => htmlToPdf(pdfRef.current, 'notification', "save")}
                                    {...commonButtonProps}
                                >
                                    PDF
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    onClick={() => htmlToPdf(pdfRef.current, 'notification', "view")}
                                    {...commonButtonProps}
                                >
                                    Print
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            size='small'
                            placeholder='Search service provider'
                            InputProps={{
                                endAdornment: <InputAdornment><Search /></InputAdornment>
                            }}
                            onChange={e => setsearchQuery(e.currentTarget.value)}
                        />
                    </Grid>
                </Grid>
                {/* data */}

                <Grid ref={pdfRef} container rowSpacing={5} item xs={12} style={{ minHeight: '100%' }}>
                    {
                        searchData.map(el => (
                            <Grid
                                container
                                item
                                xs={12}
                                key={el.title}
                                sx={{
                                    backgroundColor: '#FAF0E6',
                                    marginTop: 1,
                                    marginBottom: 1,
                                    padding: 2
                                }}
                            >
                                <Grid item xs={9}>
                                    <Typography variant='h6'>{el.title}</Typography>
                                    <Typography>{el.body}</Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={3}
                                    display='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                    flex={1}
                                >
                                    <AddNotification data={el} />
                                </Grid>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        </Box>
    )
}

export default Notifications